<template>
  <!-- 面包屑 -->
  <a-breadcrumb>
    <a-breadcrumb-item>前台配置</a-breadcrumb-item>
    <a-breadcrumb-item>首页Banner</a-breadcrumb-item>
  </a-breadcrumb>
  <!-- 功能条 -->
  <div class="tool-view">
    <div style="flex: 1;"></div>
    <a-button type="primary" @click="handleAdd()"><plus-outlined />添加banner</a-button>
  </div>
  <!-- 列表 -->
  <a-table
    class="table-view"
    :data-source="dataSource"
    :columns="columns"
    :row-key="record => record.id"
    :loading="isLoading"
    :pagination="false"
  >
    <!-- 自定义行内容 -->
    <template #bodyCell="{ column, record, index }">
      <!-- 跳转 -->
      <template v-if="column.key === 'type'">
        {{ record.type === 3 ? '自定义' : (record.type === 1 ? '短剧' : '活动页') }}
      </template>
      <!-- 跳转链接 -->
      <template v-if="column.key === 'drama_name'">
        {{ record.type === 3 ? record.redirect_url : (record.type === 1 ? record.drama_name : record.activity_title) }}
      </template>
      <!-- 操作 -->
      <template v-if="column.key === 'operation'">
      <!-- 编辑 -->
        <a-button
          type="link"
          @click="handleAdd(record)"
        >
          编辑
        </a-button>
        <!-- 删除 -->
        <a-popconfirm
          title="确定要删除吗？"
          @confirm="handleDelete(record)"
        >
          <a-button type="link">删除</a-button>
        </a-popconfirm>
        <!-- 上移：第一组禁用 -->
        <a-button
          type="link"
          @click="handleSort(record, 'up')"
          :disabled="index === 0"
        >
          上移
        </a-button>
        <!-- 下移：最后一组禁用 -->
        <a-button
          type="link"
          @click="handleSort(record, 'down')"
          :disabled="index === dataSource.length - 1"
        >
          下移
        </a-button>
      </template>
    </template>
  </a-table>
  <!-- 新增、编辑抽屉 -->
  <Add ref="RefAdd" @success="getList"></Add>
</template>

<script setup>
import { onBeforeMount, ref, reactive } from 'vue'
import { FrontSource } from '@/utils/constantList'
import { message } from 'ant-design-vue'
import Add from './components-banners/Add'
import { frontBannerList, frontBannerSort, frontBannerDelete } from '@/api/appfront'

// 新增、编辑组件实例
let RefAdd = ref(null)
// source类型
const source = FrontSource.banner
// 加载
let isLoading = ref(false)
// 数据源
let dataSource = ref([])
// 列数据源（付费转化率、权重本期不做）
let columns = ref([
  {
    title: '顺序',
    dataIndex: 'sort',
    key: 'sort'
  },
  {
    title: '文案',
    dataIndex: 'description',
    key: 'description'
  },
  {
    title: '超链类型',
    dataIndex: 'type',
    key: 'type'
  },
  {
    title: '跳转页面',
    dataIndex: 'redirect_url',
    key: 'redirect_url'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation'
  }
])

// 钩子函数
onBeforeMount(() => {
  // 获取配置列表
  getList()
})

// 获取配置列表
function getList () {
  isLoading.value = true
  frontBannerList({
    source: 'banner',
    id: 1
  }).then(res => {
    isLoading.value = false
    const { code, msg, data } = res
    if (code === 0) {
      dataSource.value = data
    } else {
      message.error(res.message || msg)
    }
  })
}

// 新增、编辑banner
function handleAdd (record) {
  RefAdd.value.showDrawer({
    // 单条记录id
    id: record ? record.id : undefined
  })
}

// 删除banner 
function handleDelete (record) {
  isLoading.value = true
  const params = {
    source,
    id: record.id
  }
  frontBannerDelete(params).then(res => {
    isLoading.value = false
    const { code, msg, data } = res
    if (code === 0) {
      message.success('删除成功')
      // 更新列表
      getList()
    } else {
      message.error(res.message || msg)
    }
  })
}

// 排序banner
function handleSort (record, type) {
  isLoading.value = true
  const params = {
    source,
    id: record.id,
    type
  }
  frontBannerSort(params).then(res => {
    isLoading.value = false
    const { code, msg, data } = res
    if (code === 0) {
      // 更新列表
      getList()
    } else {
      message.error(res.message || msg)
    }
  })
}
</script>

<style lang="less" scoped>
.tool-view {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 10px 20px;
}
.cover-img {
  display: block;
  width: 40px;
  height: 40px;
  object-fit: cover;
}
.ant-btn-link {
  padding: 0;
  margin-left: 8px;
}
</style>